<template>
  <div class="nav-collapse" :class="{ 'is-open': isOpen }">
    <img v-if="img" :src="img" />
    <font-awesome-icon class="icon mr-2" :icon="icon" />
    <span class="text">
      {{ text }}
    </span>
    <i
      class="fal fa-angle-down angle ml-2 fa-angle-down rotate"
      :class="{ down: isOpen }"
    ></i>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Array,
      default: null,
    },
    text: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.nav-collapse {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem;
  &:hover,
  &:active,
  &.is-open {
    .icon {
      color: var(--brand-color, $coral);
    }
    .text {
      color: $charcoal;
    }
  }
}

.icon {
  color: $medium-gray;
  width: 24px;
  text-align: center;
}

.text {
  flex: 1;
  user-select: none;
}

.angle {
  color: $medium-gray;
  font-size: 2rem;
  line-height: 0.9;
  height: 24px;
}
</style>
